import { useState } from "react";
import { css } from "../../../styled-system/css";
import { HStack, VStack } from "../../../styled-system/jsx";

const Section = ({ label, count, children }) => {
  const [isCollapsed, setIsCollapsed] = useState(false);
  return (
    <VStack
      alignItems="flex-start"
      width="100%"
      flex={isCollapsed ? "none" : 1}
      minHeight="32px"
      borderBottom={"1px solid #e5e7eb"}
    >
      {label && (
        <HStack
          justifyContent="space-between"
          width="100%"
          onClick={() => setIsCollapsed(!isCollapsed)}
          cursor="pointer"
          paddingBottom="8px"
        >
          <span
            className={css({
              fontSize: "12px",
              fontWeight: "600",
              color: "#666",
              textTransform: "uppercase",
            })}
          >
            {label}
          </span>
          {count > 0 && (
            <span
              className={css({
                backgroundColor: "#e5e7eb",
                padding: "2px 8px",
                borderRadius: "12px",
                fontSize: "12px",
                fontWeight: "500",
              })}
            >
              {count}
            </span>
          )}
        </HStack>
      )}
      {!isCollapsed && (
        <div
          className={css({
            width: "100%",
            maxHeight: "100%",
            overflowY: "auto",
            padding: "12px 5px 12px 0",
            "&::-webkit-scrollbar": {
              width: "6px",
            },
            "&::-webkit-scrollbar-track": {
              backgroundColor: "#f3f4f6",
            },
            "&::-webkit-scrollbar-thumb": {
              backgroundColor: "#d1d5db",
              borderRadius: "3px",
              "&:hover": {
                backgroundColor: "#9ca3af",
              },
            },
          })}
        >
          {children}
        </div>
      )}
    </VStack>
  );
};

export default Section;
